import { z } from 'zod';
import { AuditActionEnum } from './audit-event.js';

/**
 * Wire schemas for `GET /invoices/:id/audit-events` (#51, REQ3.7).
 *
 * The audit-trail panel renders an immutable timeline of every state-changing
 * action against a single invoice. Per REQ9.5 the underlying `audit_events`
 * table is append-only; this read-only endpoint never writes its own audit
 * row (read-access logging is a separate concern, tracked in #82+).
 */

export const InvoiceAuditEventSchema = z.object({
  id: z.string(),
  action: AuditActionEnum,
  /** Null for system events (e.g. queue-driven status flips). */
  userId: z.string().nullable(),
  /** Human-friendly label (email if known, "system" otherwise). */
  actorLabel: z.string(),
  /** Full before snapshot as JSON; the UI summarises diffs client-side. */
  before: z.record(z.unknown()).nullable(),
  after: z.record(z.unknown()).nullable(),
  createdAt: z.string().datetime(),
});
export type InvoiceAuditEvent = z.infer<typeof InvoiceAuditEventSchema>;

export const InvoiceAuditListResponseSchema = z.object({
  items: z.array(InvoiceAuditEventSchema),
});
export type InvoiceAuditListResponse = z.infer<typeof InvoiceAuditListResponseSchema>;
